import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';
import { Hotels, Settings } from '../../api/services/next';
import GridPanel from '../../components/GridPanel';
import { MenuActions } from '../../components/shared/constants';
import HotelsDropDown from '../../components/shared/HotelsDropDown';
import { onError, onSuccess } from '../../components/shared/messages';
import { onUpdateGridHandler } from '../../components/GridPanel/utility';

export const EmailSettings = () => {
    const [data, setData] = useState([])
    const [hotels, setHotels] = useState([])

    const save = () => {
        (async () => {
            try {
                await Settings.PostEmailSettings(data)
                onSuccess()
            } catch (error) {
                onError(error)
            }
            
        })()
    }

    const CustomCheckbox = ({onChange, ...rest})=>{
        const onCheck = (e, data)=>{
            onChange(data.checked)
        }
        return <Checkbox toggle onChange={onCheck} {...rest}/>
    }
    CustomCheckbox.propTypes = {
        onChange: PropTypes.func
    }

    useEffect(() => {
        (async () => {
            const data = await Settings.GetEmailSettings({});
            setData(data)
            const hotels = await Hotels.GetHotels({});
            setHotels(hotels)
        })()
    }, [])

    useEffect(() => {
        if (window.optima?.commands) {
            window.optima.commands.unsubscribe(MenuActions.save)
            window.optima.commands.subscribe(MenuActions.save, save);
        }
    }, [data])

    const hotelFormatter = ({value})=>{
        if (hotels){
            const hotel = hotels.find(x=>x.Id == value)
            return hotel?.Name
        }
        return null
    }
    const checkBoxFormatter = ({value})=>{
        return <CustomCheckbox readOnly checked={value}/>
    }

    const onUpdate = (added, changed, deleted) => {
        const updated = onUpdateGridHandler(data, added, changed, deleted)
        setData(updated)
    }

    const gridOptions = {
        columns: [
            { name: 'HotelId', title: 'Hotel', editor: <HotelsDropDown fluid search data={hotels} />, formatter: hotelFormatter },
            { name: 'FromEmailDisplayName', title: 'From Email Display Name' },
            { name: 'SmtpFromEmail', title: 'Smtp From Email' },
            { name: 'SmtpHost', title: 'Smtp Host' },
            { name: 'SmtpPort', title: 'Smtp Port' },
            { name: 'SmtpUserName', title: 'Smtp User Name' },
            { name: 'SmtpPassword', title: 'Smtp Password' },
            { name: 'EnableSsl', title: 'Enable Ssl', editor: <CustomCheckbox style={{marginTop: 8, marginBottom: 8}}/>, formatter: checkBoxFormatter, customProps: ({value}) => { return {checked: value}}}
        ],
        editable: {
            allowAdd: true,
            allowDelete: true,
            allowEdit: true
        }
    }

    return <div style={{
        display: "flex",
        flex: 1,
        flexDirection: "column"
    }}>
        <GridPanel options={gridOptions} data={data} onUpdate={onUpdate}/>
    </div>
}